import gsap from 'gsap';

const reviewsModal = () => {
	const modal = document.querySelector('.reviews__modal');
	if (!modal) return;

	const modalTitle = modal.querySelector('.reviews__modal__title');
	const modalText = modal.querySelector('.reviews__modal__text');
	const modalAuthor = modal.querySelector('.reviews__modal__author');
	const modalPosition = modal.querySelector('.reviews__modal__position');
	const modalClose = modal.querySelector('.reviews__modal__close');
	const triggers = document.querySelectorAll('.review__more');

	const openModal = (review) => {
		modalTitle.textContent = review.title || '';
		modalTitle.style.display = review.title ? '' : 'none';

		modalText.innerHTML = review.text || '';
		modalText.style.display = review.text ? '' : 'none';

		modalAuthor.textContent = review.author || '';
		modalAuthor.style.display = review.author ? '' : 'none';

		modalPosition.textContent = review.position || '';
		modalPosition.style.display = review.position ? '' : 'none';

		modal.showModal();

		gsap.fromTo(modal, {
			opacity: 0,
			scale: 0.95
		}, {
			opacity: 1,
			scale: 1,
			duration: 0.4,
			ease: 'power2.out'
		});
	};

	const closeModal = () => {
		modal.close();
	};

	triggers.forEach(btn => {
		btn.addEventListener('click', () => {
			const id = parseInt(btn.dataset.reviewId, 10);
			const review = reviewsData.find(r => r.id === id);
			if (review) openModal(review);
		});
	});

	modalClose.addEventListener('click', closeModal);
};

export default reviewsModal;